import moment from 'moment';
import { ToastProgrammatic as Toast, NotificationProgrammatic as Notification } from 'buefy';
import {
  pushToFirebase, getUserFirebaseStatus, singOut, logInAnon, getElementFromFirebase,
  setToFirebase, getItemsFromFirebase, removeItemFromFirebase,
} from '../../../mixins/firebase';

const axios = require('axios').default;

export default {
  createAccount(context, data) {
    const user = {
      userKey: data.userKey,
    };
    pushToFirebase(`${data.key}`, user);
  },

  async getUser(context) {
    // in firebase I should take care of saving user id, otherwise actions in the app will break
    // if (localStorage.getItem('user'))
    // context.dispatch('applicationStore/isPageLoading', false, { root: true });
    // setTimeout(() => {
    //   context.dispatch('applicationStore/isPageLoading', false, { root: true });
    // }, 10 * 1000);

    try {
      const resolveAfterLogin = await getUserFirebaseStatus();
      if (resolveAfterLogin) {
        context.commit('GET_USER', resolveAfterLogin);
        context.dispatch('gamefyStore/getUserApiKey', false, { root: true });
        await context.dispatch('getUserNick');
        return resolveAfterLogin;
      }
      await context.dispatch('getUserNick');
      return null;
    } catch (e) {
      console.log(e);
    }
    return null;
  },

  logOutUser(context) {
    singOut().then(() => {
      context.commit('GET_USER', {});
      localStorage.setItem('user', '');
      localStorage.setItem('allLogs', null);
      localStorage.setItem('allHabits', null);
      window.location.reload(true);
    });
  },

  logInAnonUser(context) {
    logInAnon().then(() => {
      context.dispatch('getUser');
    });
  },
  setLoginModalDisplay(context, data) {
    context.commit('SET_DISPLAY_LOGIN_MODAL', data);
  },
  async getUserNick(context) {
    const updateNick = (nick) => { context.commit('UPDATE_NICK', nick); };
    await getElementFromFirebase('nick', updateNick);
  },
  updateNick(context, nick) {
    context.commit('UPDATE_NICK', nick);
    setToFirebase('nick', nick);
  },
  setParamToUser(_, { name, value }) {
    if (!(name && value)) return;
    setToFirebase(name, value);
  },

  async observFriend({ dispatch }, nickToken) {
    Notification.open({
      message: 'Dodaje znajomego',
      type: 'is-white',
      position: 'is-bottom',
    });
    const isFriendExist = await axios({
      method: 'post',
      url: 'https://us-central1-jedeadmin.cloudfunctions.net/app/api/friends/add',
      data: {
        nickToken,
      },
    });
    const friends = await getItemsFromFirebase('friends');
    const friendsIds = friends.map((friend) => friend.value);
    const isExist = friendsIds.some((item) => item === nickToken);
    // do tłumaczenia
    if (isFriendExist.data && !isExist) {
      try {
        await pushToFirebase('friends', nickToken);
        await dispatch('getFriends');
        // api nie zwraca errora kiedy nie ma znajomego
        Notification.open({
          message: 'Znajomy dodany!',
          type: 'is-success',
          position: 'is-bottom',
        });
      } catch (e) {
        Notification.open({
          message: `Wystąpił problem: ${e}`,
          type: 'is-danger',
          position: 'is-bottom',
        });
      }
    }
  },
  async removeFriend({ dispatch }, { firekey }) {
    await removeItemFromFirebase('friends', firekey);
    await dispatch('getFriends');
    Toast.open({
      message: 'Usunięto znajomego',
      position: 'is-bottom',
      type: 'is-danger',
    });
  },
  async getFriends({ commit }, selectedDay) {
    const friends = await getItemsFromFirebase('friends');
    const friendsNicks = friends.map((friend) => friend.value);

    const getFriendDate = async (id) => {
      const friendsFromStorage = JSON.parse(localStorage.getItem('friends'));

      if (friendsFromStorage) {
        commit('PUSH_FRIENDS_DATA', friendsFromStorage.map((item) => ({ ...item, onPlan: 0, done: 0 })));
      }

      const friendDate = await axios({
        method: 'post',
        url: 'https://us-central1-jedeadmin.cloudfunctions.net/app/api/stats',
        data: {
          nickToken: id,
          startDate: moment(selectedDay).format('DD-MM-YYYY'),
        },
      });
      return friendDate;
    };
    const promises = [];
    friendsNicks.forEach((id) => {
      promises.push(getFriendDate(id));
    });
    try {
      const responses = await Promise.all(promises);
      const friendsDate = [];
      responses.forEach((response, index) => {
        friendsDate.push({
          ...response.data,
          firekey: friends[index].firekey,
        });
      });
      localStorage.setItem('friends', JSON.stringify(friendsDate));
      commit('PUSH_FRIENDS_DATA', friendsDate);
      return true;
    } catch (e) {
      console.log(e);
      return true;
    }
  },
};
